module.exports = __webpack_public_path__ + "static/media/bb8-rejected-24px.c674987d.svg";